var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-tag',{attrs:{"disabled":_vm.filter.disabled},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_vm._v(" "+_vm._s(_vm.filter.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }